import { captureExceptionWithContext } from "@/sentry";

// Backend error codes that represent expected user-facing validation failures
// (e.g. deleting a team that's still part of a session).
const EXPECTED_ERROR_CODES = new Set(["CAN_NOT_DELETE"]);

export async function catched(response, pagination) {
  try {
    const res = await response;
    return { success: true, data: res, pagination };
  } catch (e) {
    const errorCode = e.contexts?.response?.code;
    if (!EXPECTED_ERROR_CODES.has(errorCode)) {
      void captureExceptionWithContext(e);
    }
    return {
      success: false,
      error: e.userMessage || e.message,
      errorCode,
    };
  }
}
